import { useEffect, useState } from 'react';

import ReactJson from '@microlink/react-json-view';
import Header from './Header';
import Spinner from './Spinner';
import StatusBar from './StatusBar';
import ajax from './ajax';
import { Typography } from '@mui/material';
import { PrimaryButton, SecondaryButton } from '@client/new/components/button';

const JSONFileEditor = ({
  configFileContent,
  onUpdate,
}: {
  configFileContent: object;
  onUpdate: (data: unknown) => void;
}) => {
  const onChange = (data: { updated_src: unknown }) => {
    const content = data.updated_src;
    return onUpdate(content);
  };

  return (
    <ReactJson
      style={{
        padding: '20px',
      }}
      src={configFileContent}
      collapsed={false}
      name={'configFile'}
      theme="summerfruit:inverted"
      onEdit={onChange}
      onAdd={onChange}
      onDelete={onChange}
    />
  );
};

const ConfigFileEditor = () => {
  const [fetching, setFetching] = useState(false);
  const [configFileContent, setConfigFileContent] = useState({});

  const fetchConfigFile = async () => {
    try {
      setFetching(true);
      const configlFile = await ajax.getConfigFile();
      setConfigFileContent(configlFile);
      setFetching(false);
    } catch (err) {
      setFetching(false);
      StatusBar.sendErrorMessage(
        'Config file was not fetched, please try again.',
      );
    }
  };

  useEffect(() => {
    fetchConfigFile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const mergeUpdatedConfigFile = (updatedConfigFile) => {
    setConfigFileContent(updatedConfigFile);
  };

  const removeWholeJSON = () => {
    setConfigFileContent({});
  };

  const saveChanges = async () => {
    try {
      setFetching(true);
      const updatedConfgilFile = await ajax.updateConfigFile(configFileContent);
      setConfigFileContent(updatedConfgilFile);
      setFetching(false);
    } catch (err) {
      setFetching(false);
      StatusBar.sendErrorMessage(
        'Config file was not updated, please try again',
      );
    }
  };

  const cancelChanges = async () => {
    try {
      setFetching(true);
      await fetchConfigFile();
    } catch (err) {
      setFetching(false);
      StatusBar.sendErrorMessage(
        'Config file was not fetched, please try again',
      );
    }
  };

  return (
    <div>
      <Header>
        <Typography variant="h3">Config File Editor</Typography>
        <div className="flex flex-row gap-3">
          <div className="button-box">
            <PrimaryButton onClick={async () => await saveChanges()}>
              Save
            </PrimaryButton>
          </div>
          <div className="button-box">
            <SecondaryButton onClick={async () => await cancelChanges()}>
              Cancel
            </SecondaryButton>
          </div>
          <div className="button-box">
            <SecondaryButton onClick={async () => await removeWholeJSON()}>
              Reset JSON
            </SecondaryButton>
          </div>
        </div>
      </Header>
      <div className="workoutList">
        <main id="main">
          {fetching ? (
            <Spinner color={`#6367ef`} />
          ) : (
            <div>
              <JSONFileEditor
                configFileContent={configFileContent}
                onUpdate={(data) => {
                  return mergeUpdatedConfigFile(data);
                }}
              />
            </div>
          )}
        </main>
      </div>
      <StatusBar.Component />
    </div>
  );
};

export default ConfigFileEditor;
